<p>
  show-recurring-selected-timeslot works!
</p>
